var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import PolicyAnalysisUploadApi from '~/api/policy-analysis-upload';
import PresignedUrlUploadApi from '~/api/presigned-url-upload';
const uploadFile = (file, metadata) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const policyResponse = yield makeRequestWithRetry(PolicyAnalysisUploadApi.post({ metadata }));
    if (!policyResponse)
        throw Error('Error calling API');
    if (policyResponse.statusCode !== 200)
        throw Error(`Error: ${policyResponse.message}`);
    const errorData = policyResponse.data;
    if (errorData.errorMessage) {
        throw Error(errorData.errorMessage);
    }
    const fileId = (_b = (_a = policyResponse === null || policyResponse === void 0 ? void 0 : policyResponse.data) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.id;
    const transferUrl = (_d = (_c = policyResponse === null || policyResponse === void 0 ? void 0 : policyResponse.data) === null || _c === void 0 ? void 0 : _c.presignedUrl) === null || _d === void 0 ? void 0 : _d.fileTransferUrl;
    if (!fileId || !transferUrl) {
        throw Error(`Error: Invalid file ID (${fileId}) or transfer URL (${transferUrl})`);
    }
    const uploadResponse = yield makeRequestWithRetry(PresignedUrlUploadApi.put(transferUrl, file));
    if (!uploadResponse)
        throw Error('Error: Failed uploading file to S3');
    const finalResponse = yield makeRequestWithRetry(PolicyAnalysisUploadApi.update(fileId, {}));
    if (!finalResponse)
        throw Error('Error: Failed call updating file data');
    if (finalResponse === null || finalResponse === void 0 ? void 0 : finalResponse.duplicateFile) {
        throw Error(`Error: Duplicate file hash: ${finalResponse.duplicateFile}`);
    }
    return 'Successfully uploaded file!';
});
const makeRequestWithRetry = (promise) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield promise;
        if (!response)
            throw Error('Retry');
        return response;
    }
    catch (_a) {
        console.log('Request Failed. Retrying...');
        return yield promise;
    }
});
export default uploadFile;
